import { jsx } from 'react/jsx-runtime';
import { ItemTreeNode } from '../../util/ItemTree/ItemTreeNode.js';

function MenuSeparator() {
  return /*#__PURE__*/jsx(ItemTreeNode, {
    type: "menu-separator"
  });
}

export { MenuSeparator };
